import { RootState } from '@Store/index';
import {
  getOverseasSponsorsDictSelector,
  getOverseasStatusesDictSelector,
} from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { transformDictToOptions } from '@Utils/transformToOptions';
import { createSelector } from '@reduxjs/toolkit';

const overseasMission = (state: RootState) =>
  state.featureStores.overseasMission;

export const currentOverseasMission = createSelector(
  overseasMission,
  ({ overseasMission }) => overseasMission
);

export const overseasMissionCreateRequisitionInfo = createSelector(
  [currentOverseasMission, getOverseasStatusesDictSelector],
  (overseasMission, overseasStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(
      overseasMission,
      overseasStatuses
    );
    return requisitionInfo;
  }
);

export const getSponsorOptions = createSelector(
  [getOverseasSponsorsDictSelector],
  (sponsorsDict) => {
    return transformDictToOptions(sponsorsDict);
  }
);

export const getStatusLabels = createSelector(
  [getOverseasStatusesDictSelector],
  (statuses) => {
    return statuses.map((status) => status.codeDesc);
  }
);
